// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/invStartUp/heredity/style.less
// module id = 2267
// module chunks = 0